import { Col, Row } from 'antd'
import React, { useState } from 'react'
import ActiveJobRoles from './ActiveJobRoles'
import DonutWithCustomLegend from './DonutWithCustomLegend'
import StudentPlacement from './StudentPlacement'
import { StyledShadowBox } from './StyledComponent'

export default function TPOGraphs({
  activeJobRoles,
  activeJobRolesRef,
  jobProfileStatusDetails,
  jobProfileStatusRef,
  isDownload,
  studentPlacementObj,
  studentPlacementRef,
  ctcAnalysis,
  studentPlacement,
  percentageObj,
  ctcCategory,
  studentPlacementArr,
  ctcAnalysisRef,
  ctcCategoryRef,
  state,
}) {
  const { selectedCategory } = state
  const placement = selectedCategory === 'PLACEMENT'
  const gigs = selectedCategory === 'GIGS'

  const [ctcSelected, setCtcSelected] = useState(false)
  const [isCTCCategory, setIsCTCCategory] = useState(false)

  return (
    <div>
      {activeJobRoles?.length > 0 && (
        <StyledShadowBox>
          <ActiveJobRoles
            activeJobRolesRef={activeJobRolesRef}
            data={activeJobRoles}
            state={state}
          />
        </StyledShadowBox>
      )}
      {jobProfileStatusDetails?.length > 0 && (
        <StyledShadowBox>
          <DonutWithCustomLegend
            label={jobProfileStatusDetails?.map(item => item?.label)}
            labelValues={jobProfileStatusDetails?.map(item => item?.value)}
            backgroundColor={jobProfileStatusDetails?.map(
              item => item?.background
            )}
            title={'Job Profile Status'}
            description={
              ' Data below shows the indication of statuses of the roles floated overall.'
            }
            legend
            graphRef={jobProfileStatusRef}
            isDownload={isDownload}
            type={'profileStatus'}
            currentData={jobProfileStatusDetails}
            state={state}
          />
        </StyledShadowBox>
      )}
      {studentPlacement?.length > 0 ? (
        <StyledShadowBox>
          <Row>
            <Col md={8} xs={24}>
              <DonutWithCustomLegend
                label={placement ? ['Placed', 'Un-Placed', 'Opt-out'] : ['Selected', 'Un-Selected', 'Opt-out']}
                labelValues={[
                  studentPlacementObj?.totalPlacedCount,
                  studentPlacementObj?.totalUnplacedCount,
                  studentPlacementObj?.totalOptedOutCount,
                ]}
                backgroundColor={['#0FB680', '#F54B56', '#6B7280']}
                title={placement ? 'Students Placement' : 'Students Selected'}
                description={
                  <>
                    Data below shows {placement ? 'placed' : 'selected'} & not-
                    {placement ? 'placed' : 'selected'} students Overall and by
                    their{' '}
                    <strong>
                      {state?.selectedSpecialization.length > 0
                        ? 'Domain, Degree, Department & Specialization'
                        : state?.selectedDepartment.length > 0
                        ? 'Domain, Degree & Department'
                        : state?.selectedDegree.length > 0
                        ? 'Domain & Degree'
                        : 'Domain'}
                    </strong>
                  </>
                }
                graphRef={studentPlacementRef}
                isDownload={isDownload}
                onlyChart
                state={state}
              />
            </Col>
            <Col md={16} xs={24}>
              <StudentPlacement
                data={studentPlacement}
                percentageObj={percentageObj}
                studentPlacementArr={studentPlacementArr}
                state={state}
              />
            </Col>
          </Row>
        </StyledShadowBox>
      ) : null}
      {ctcAnalysis?.length > 0 ? (
        <StyledShadowBox>
          <Row gutter={30}>
            {ctcAnalysis?.length > 0 && (
              <Col md={12} xs={24}>
                <DonutWithCustomLegend
                  label={ctcAnalysis?.map(item => item?.label)}
                  labelValues={ctcAnalysis?.map(item => item?.value)}
                  backgroundColor={ctcAnalysis?.map(item => item?.background)}
                  title={
                    placement || gigs ? 'CTC Analysis' : 'Stipend Analysis'
                  }
                  type={'ctc'}
                  description={`Data below compares the salary packages of students ${
                    placement ? 'placed' : 'selected'
                  }`}
                  legend
                  legendRow={12}
                  graphRef={ctcAnalysisRef}
                  currentData={ctcAnalysis}
                  state={state}
                  setCtcSelected={setCtcSelected}
                  donutType={'ctcAnalysis'}
                  setIsCTCCategory={setIsCTCCategory}
                  isCTCCategory={isCTCCategory}
                  isDownload={isDownload}
                />
              </Col>
            )}
            {ctcCategory?.length > 0 && (
              <Col md={12} xs={24} style={{ borderLeft: '1px solid #D5D5D5' }}>
                <DonutWithCustomLegend
                  label={ctcCategory?.map(item => item?.label)}
                  labelValues={ctcCategory?.map(item => item?.value)}
                  backgroundColor={['#1E90FF', '#556BD9', '#76D7C4', '#7DF9FF']}
                  title={
                    placement || gigs ? 'CTC Category' : 'Stipend Category'
                  }
                  description={''}
                  legendOnly
                  graphRef={ctcCategoryRef}
                  currentData={ctcCategory}
                  state={state}
                  type={'ctc'}
                  ctcSelected={ctcSelected}
                  ctcCategory
                  donutType={'ctcCategory'}
                  setIsCTCCategory={setIsCTCCategory}
                  isCTCCategory={isCTCCategory}
                  legend
                  isDownload={isDownload}
                />
              </Col>
            )}
          </Row>
        </StyledShadowBox>
      ) : null}
    </div>
  )
}
